import React from "react";
import "../dashboard.css";

export default function Eventos() {
    return (
        <div>
            <h1 className="dashboardTitle">Administrar Eventos</h1>
            <p className="dashboardSubtitle">Próximamente: Panel para crear y gestionar eventos.</p>
        </div>
    );
}
